module.exports = __webpack_public_path__ + "static/media/about-jonathan.4f561f1a.jpg";